module.exports = __webpack_public_path__ + "static/media/6.efe466f0.jpg";